import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Kraken4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KRAKEN4;
}

export default Kraken4PoiTileEntity;
